import { LoanappService } from './../../services/loanapp.service';
import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { AuthService } from 'app/services/auth.service';
import { ToastrService } from 'ngx-toastr';
import * as moment from 'moment';

declare var $: any;

@Component({
  selector: 'app-loanapplicationsdetails',
  templateUrl: './loanapplicationsdetails.component.html',
  styleUrls: ['./loanapplicationsdetails.component.css'],
})
export class LoanapplicationsdetailsComponent implements OnInit {
  appId: string;
  uId: string;
  appdetails: any;
  wdepositDetails: any;
  dataRec: any;
  insDetails: any;
  dataToShow: any;
  dataToShowR: any;
  isReadOnly: boolean = true;
  farmerDetails: any;
  statess = true;
  ifUpdated: boolean = false;
  saveBtn: boolean = false;
  InsuranceDetails: boolean = false;
  capacityLessThanQuantity: boolean = true;
  fieldEmpty: boolean = false;
  perUnitValue: string = '';
  totalMarketValue: string = '';
  unit: string = '';
  updateBtn: string = 'Update';
  auditResult: string = '';
  cas: string = '';
  datetime: string = '';
  cOname: string = '';
  cCname: string = '';
  clickedOnApprove: boolean = false;
  loanAmount: string | number = '';
  processingFee: string = '';
  rateOfInt: string = '';
  loanTenor: string = '';
  remark: string = '';
  emiAmount: string = '';
  repaymentSchedule: string = '';
  pageType: string = '';
  approveLoanBtn: boolean = false;
  showNoDetails: boolean = false;
  receiptG: boolean = false;
  kycDocsUploaded: any[] = [];
  auditStart: Date | string;
  auditEnd: Date | string;

  accountType: string = 'PREPAID/CC';
  accountNumber: string = 'XXXXXXX323232';
  networkStatus: string = 'ACTIVE';
  accStatus: string = 'ACTIVE';
  limit: number = 0;
  termLoan: number = 0;
  user: any;
  baseURI = '';
  myAngularxQrCode: string = null;
  qrCode: boolean = false;
  valMsgLamount: boolean = false;
  valMsgLamountOverlimit: boolean = false;
  valMsgPfee: boolean = false;
  valMsgEmi: boolean = false;
  valMsgROI: boolean = false;
  valMsgLT: boolean = false;
  valMsgRS: boolean = false;
  valMsgRSInvalid: boolean = false;
  capacity: any;
  ref: any;
  viewOnly: boolean = false;
  commodityPrice: Object;
  showLoanAmountByUserMessage: Boolean = false;
  limitDetails: any;
  deliveryDetails: any;
  eligibleAmount: number;
  showSaveButtonForLendingPartner: Boolean = false;
  lendingPartners: any;
  lendingPartner: any = '';
  bankUserEntity: any;
  saveLpBtnClicked: Boolean = false;

  constructor(
    private activatedRoute: ActivatedRoute,
    private lservice: LoanappService,
    private router: Router,
    private auth: AuthService,
    private toastr: ToastrService
  ) {
    if (window.location.href.includes('beta')) {
      this.baseURI = 'https://beta-warehouses.whrrl.in';
    } else if (window.location.href.includes('localhost')) {
      this.baseURI = 'https://uat-warehouses.whrrl.in';
    } else if (window.location.href.includes('uat')) {
      this.baseURI = 'https://uat-warehouses.whrrl.in';
    } else if (window.location.href.includes('dbank')) {
      this.baseURI = 'https://dwarehouses.whrrl.in';
    } else {
      this.baseURI = 'https://warehouses.whrrl.in';
    }

    this.activatedRoute.queryParams.subscribe((params) => {
      this.appId = params['id'];
      this.uId = params['uId'];
      this.ref = params['ref'];
      this.pageType = params['p'];
      this.viewOnly = params['viewOnly'] ? params['viewOnly'] : false;
      if (this.pageType) {
        this.showNoDetails = true;
      } else {
        this.showNoDetails = false;
      }
    });
  }

  ngOnInit() {
    this.user = this.auth.user;

    this.getData();
  }

  getData() {
    this.lservice.getLoanAppDetails(this.appId, this.uId).subscribe(
      (data) => {
        this.dataRec = true;
        if (data['success']) {
          this.getCommodityPrice(data['_id']);
          this.getLendingPartners();
          this.wdepositDetails = data['data'];
          this.appdetails = data['lapp'];
          this.capacity = data['capacity'];
          this.dataToShow = data['lapp'];
          this.farmerDetails = data['user'];
          this.insDetails = data['insD'];
          this.bankUserEntity = data['bank'];
          this.limitDetails = data['limitDetails'];
          this.deliveryDetails = data['delivery'];
          this.capacityLessThanQuantity = this.checkRemainingCapacity(
            this.capacity
          );

          const depositAmtAfterDelivery =
            this.wdepositDetails.totalReceiptValue -
            this.deliveryDetails.totalValue;

          this.eligibleAmount = depositAmtAfterDelivery;

          if (
            this.farmerDetails.userType === 'trader' ||
            this.farmerDetails.userType === 'Trader' ||
            this.farmerDetails.userType === 'Traders'
          ) {
            if (depositAmtAfterDelivery < this.limitDetails.limitBalance) {
              this.eligibleAmount = depositAmtAfterDelivery;
            } else if (
              depositAmtAfterDelivery > this.limitDetails.limitBalance
            ) {
              this.eligibleAmount = this.limitDetails.limitBalance;
            }
          }
          if (
            this.appdetails['loanAmountByUser'] &&
            this.appdetails['loanAmountByUser'] != 0
          ) {
            this.loanAmount = Number(this.appdetails['loanAmountByUser']);
            this.showLoanAmountByUserMessage = true;
          }

          this.myAngularxQrCode =
            this.baseURI +
            '/receipt?appId=' +
            this.wdepositDetails['_id'] +
            '&uId=' +
            this.uId;
          if (this.appdetails.audit) {
            this.cCname = this.appdetails.audit.cCname;
            this.cOname = this.appdetails.audit.cOname;
            this.auditResult = this.appdetails.audit.auditResult;
            this.cas = this.appdetails.audit.cas;
            this.datetime = this.appdetails.audit.datetime;
            this.auditStart = this.appdetails.audit.auditStart;
            this.auditEnd = this.appdetails.audit.auditEnd;
          }
          if (!this.insDetails) {
            this.InsuranceDetails = false;
          } else {
            this.InsuranceDetails = true;
          }

          if (this.appdetails.approved) {
            this.loanAmount = this.appdetails.approved.loanAmount;
            this.emiAmount = this.appdetails.approved.emiAmount;
            this.loanTenor = this.appdetails.approved.loanTenor;
            this.processingFee = this.appdetails.approved.processingFee;
            this.rateOfInt = this.appdetails.approved.rateOfInt;
            this.repaymentSchedule = moment(
              this.appdetails.approved.repaymentSchedule
            ).format('YYYY-MM-DD');
          }
          if (
            this.farmerDetails &&
            this.farmerDetails.kycDocuments &&
            this.farmerDetails.kycDocuments.length
          ) {
            this.kycDocsUploaded = this.farmerDetails.kycDocuments;
          }
        } else {
          if (data['err'] == 'Deposit Application Not Found') {
            this.toastr.error('No WHR found against this application.');
          } else {
            this.toastr.error('Error Occurred');
          }
        }
      },
      (err) => {
        console.log(err, 'API Error');
        // this.toastr.error("Error occurred. Please try again.");
        // $('#error').modal('show')
      }
    );
  }

  getLendingPartners() {
    this.lservice.lendingPartners().subscribe(
      (data) => {
        if (data['data'].length > 0) this.lendingPartners = data['data'];
      },
      (err) => {
        console.log(err, 'API Error');
      }
    );
  }

  getCommodityPrice(depositId) {
    this.lservice.getCommodityPrice(this.appId).subscribe(
      (data) => {
        if (data['data'].length > 0) this.commodityPrice = data['data'];
      },
      (err) => {
        console.log(err, 'API Error');
      }
    );
  }

  seeReceipt() {
    let elem: HTMLElement = document.getElementById('generateReceipt');
    elem.click();
  }
  viewConsent() {
    window.open(
      '/sanction-consent?appId=' + this.appId + '&uId=' + this.uId,
      '_blank'
    );
  }

  checkType() {
    if (this.farmerDetails['aadharUrl']) {
      if (this.farmerDetails['aadharUrl'].includes('.pdf')) {
        return true;
      } else {
        return false;
      }
    }
  }

  openPdf(val) {
    window.open(
      val,
      '_blank' //
    );
  }

  checkTypeP() {
    if (this.farmerDetails['panUrl']) {
      if (this.farmerDetails['panUrl'].includes('.pdf')) {
        return true;
      } else {
        return false;
      }
    }
  }

  goBack() {
    if (this.ref) {
      window.location.href = this.ref;
    } else {
      window.location.href = '/dashboard';
    }
  }

  sendnoti() {
    window.location.href =
      '/sendnotification?id=' + this.appId + '&uId=' + this.uId;
  }

  cmaReport() {
    window.open('/cmareport?id=' + this.appId + '&uId=' + this.uId, '_blank');
    // window.location.href = '/cmareport?id=' + this.appId + '&uId=' + this.uId;
  }

  userKyc() {
    $('#userKyc').modal('show');
  }
  userKycDocs() {
    $('#userKycDocs').modal('show');
  }
  userKycV() {
    $('#userKycV').modal('show');
  }

  viewKYCDoc(name) {
    console.log(name);
    let r = this.searchArrA(this.farmerDetails.kycDocuments, name);
    console.log(r);
    if (r) {
      window.open(r.url, '_blank');
    }
  }
  searchArrA(myArray, name) {
    for (var i = 0; i < myArray.length; i++) {
      if (myArray[i].name === name) {
        return myArray[i];
      }
    }
  }

  qrCodee() {
    this.receiptG = false;
    this.qrCode = true;
  }

  reC() {
    this.receiptG = true;
    this.qrCode = false;
  }

  print(cmpName) {
    window.open(
      this.baseURI +
        '/receipt?appId=' +
        this.wdepositDetails['_id'] +
        '&uId=' +
        this.uId +
        '&data=print',
      '_blank' //
    );

    // document.body.innerHTML = orgContent;
  }

  submitProfile() {
    if (this.isReadOnly) {
      this.updateBtn = 'Cancel';
    } else {
      this.updateBtn = 'Update';
    }
    this.isReadOnly = !this.isReadOnly;
    this.statess = !this.statess;
    this.ifUpdated = !this.ifUpdated;
  }

  addInsurance() {
    window.location.href =
      '/addinsurance?id=' + this.appId + '&uId=' + this.farmerDetails['_id'];
  }

  accept() {
    $('#accept').modal('show');
  }

  cancelaccept() {
    $('#accept').modal('hide');
  }
  reject() {
    $('#reject').modal('show');
  }

  rejectNow() {
    let obj = {
      id: this.appdetails['_id'],
      status: 'rejected',
    };
    this.lservice.changeStatus(obj).subscribe(
      (data) => {
        if (data['success']) {
          this.getData();
          $('#reject').modal('hide');
          $('#rejected').modal('show');
        }
      },
      (err) => {
        $('#reject').modal('hide');
        $('#error').modal('show');
      }
    );
  }

  cancelreject() {
    $('#reject').modal('hide');
  }

  approvePage() {
    if (this.insDetails.nameOfIC == '') {
      $('#noinsurance').modal('show');
    } else {
      if (
        this.user.userType === 'bankUser' &&
        this.appdetails.checkedByMaker &&
        this.appdetails.approved
      ) {
        const makerApproved = { ...this.appdetails.approved };
        this.loanAmount = makerApproved.loanAmount;
        this.processingFee = makerApproved.processingFee;
        this.loanTenor = makerApproved.loanTenor;
        this.emiAmount = makerApproved.emiAmount;
        this.rateOfInt = makerApproved.rateOfInt;
        this.repaymentSchedule = moment(makerApproved.repaymentSchedule).format(
          'YYYY-MM-DD'
        );
      }

      this.clickedOnApprove = true;
      setTimeout(() => {
        document.body.scrollTop = document.documentElement.scrollTop = 0;
      }, 100);
    }
  }

  ap() {
    $('#noinsurance').modal('hide');
    this.clickedOnApprove = true;
    setTimeout(() => {
      document.body.scrollTop = document.documentElement.scrollTop = 0;
    }, 100);
  }

  approve() {
    this.valMsgLamount = false;
    this.valMsgPfee = false;
    this.valMsgROI = false;
    this.valMsgEmi = false;
    this.valMsgLT = false;
    this.valMsgRS = false;
    let obj = {
      loanAmount: this.loanAmount,
      processingFee: this.processingFee,
      loanTenor: this.loanTenor,
      emiAmount: this.emiAmount,
      rateOfInt: this.rateOfInt,
      repaymentSchedule: this.repaymentSchedule,
      remark: this.remark
    };
    if (!this.loanAmount) {
      this.valMsgLamount = true;
    }

    if (!this.processingFee) {
      this.valMsgPfee = true;
    }
    if (!this.loanTenor) {
      this.valMsgLT = true;
    }
    if (!this.emiAmount) {
      this.valMsgEmi = true;
    }
    if (!this.rateOfInt) {
      this.valMsgROI = true;
    }
    if (!this.repaymentSchedule) {
      this.valMsgRS = true;
    }
    if (
      !this.loanAmount ||
      !this.processingFee ||
      !this.loanTenor ||
      !this.emiAmount ||
      !this.rateOfInt ||
      !this.repaymentSchedule
    ) {
      return false;
    }

    // if (+this.loanAmount > +this.wdepositDetails.totalMarketValue) {
    //   this.valMsgLamountOverlimit = true;
    //   return;
    // }

    // Limit application doesn't required for below banks
    let arrayOfbId = [
      // '5e7fd6cce7f0c126524e44bb',
      // '5fe5dc8969273e6f04c87e46',
      // '62147c0ef1cf3c695f57d3c5',
      // '5ec27f3023c33106a9b4e48a',
      // '5fb61ae59d5d6b0e31f42364'
    ];

    var hasValue = arrayOfbId.indexOf(this.appdetails['bId']) > -1;
    const mswcCustId = this.farmerDetails.mswcCustId || '';

    console.log(mswcCustId);
    const isTrader = mswcCustId.startsWith('003');
    const isFPO = mswcCustId.startsWith('002');
    console.log(hasValue);
    // if ((!hasValue && isFPO) || isTrader) {
    // if (!hasValue && isFPO) { //Code commented on 24/01/25 as "FPO getting eligible amount error even after mentioning 70% of stock value"
    //   if (+this.loanAmount > +this.eligibleAmount) {
    //     console.log('Loan amount is bigger');
    //     console.log(+this.loanAmount);
    //     console.log(+this.eligibleAmount);
    //     this.valMsgLamountOverlimit = true;
    //     return;
    //   }
    // }

    const dateRegex = new RegExp(/\b[0-9]{4}-[0-9]{2}-[0-9]{2}\b/);
    if (!dateRegex.test(this.repaymentSchedule)) {
      this.valMsgRSInvalid = true;
      return;
    }

    $('#approve').modal('show');
  }

  isEmpty(obj: any) {
    for (let v in obj) {
      if (obj[v] === undefined || obj[v] === '' || obj[v] === null) {
        return false;
      }
    }
    return true;
  }

  approveNow() {
    // *************************************************
    // This was commented on 26 july. Upgrading branch based login in Bank Panel.

    // if (this.user.userType === 'bankUser') {
    //   this.checkerLoanApprove();
    // } else if (this.user.userType === 'bankSubUser') {
    //   this.makerLoanApprove();
    // }

    // *************************************************

    // code updated for maker and checker [ Branch based login implemented.
    if (this.user.uTypeEntity === 'checker') {
      this.checkerLoanApprove();
    } else if (this.user.uTypeEntity === 'maker') {
      this.makerLoanApprove();
    }
  }
  // Loan Application approval by MAKER.
  /* 
   1. Object containing all params for approving loan application.
   2. Calling maker approval (checkedByMaker) function.
   3. Handling response and Hiding Modals
   4. Reloading Page to refresh data.
   5. Error handling
   */
  makerLoanApprove() {
    this.approveLoanBtn = true;
    // 1. Object containing all params for approving loan application.
    let obj = {
      aId: this.appdetails['_id'],
      loanAmount: this.loanAmount,
      processingFee: this.processingFee,
      loanTenor: this.loanTenor,
      emiAmount: this.emiAmount,
      rateOfInt: this.rateOfInt,
      repaymentSchedule: this.repaymentSchedule,
    };
    // 2. Calling maker approval (checkedByMaker) function.
    this.lservice.checkedByMaker(obj).subscribe(
      (data) => {
        // 3. Handling response and Hiding Modals
        this.approveLoanBtn = false;
        this.limit = Number(this.loanAmount) / 2;
        this.termLoan = Number(this.loanAmount) / 2;
        // Calling function to refresh data on page
        this.getData();
        $('#approve').modal('hide');
        $('#noinsurance').modal('hide');
        $('#maker-checked-modal').modal('show');
        // 4. Reloading Page to refresh data.
        setTimeout(() => {
          this.okFinish();
        }, 1000);
      },
      (err) => {
        $('#approve').modal('hide');
        $('#noinsurance').modal('hide');
        // 5. Error handling
        this.approveLoanBtn = false;
        this.toastr.error('Something went wrong. Please try again.');
        $('#error').modal('show');
      }
    );
  }

  checkerLoanApprove() {
    this.approveLoanBtn = true;
    let obj = {
      aId: this.appdetails['_id'],
      loanAmount: this.loanAmount,
      processingFee: this.processingFee,
      loanTenor: this.loanTenor,
      emiAmount: this.emiAmount,
      rateOfInt: this.rateOfInt,
      repaymentSchedule: this.repaymentSchedule,
      remark: this.remark,
    };
    if (!this.isEmpty(obj)) {
      $('#approve').modal('hide');
      $('#noinsurance').modal('hide');
      this.approveLoanBtn = false;
      this.fieldEmpty = true;
      let self = this;
      setTimeout(() => {
        self.fieldEmpty = false;
      }, 3000);
    } else {
      this.lservice.approveLoanApplication(obj).subscribe(
        (data) => {
          this.approveLoanBtn = false;
          if (data['success']) {
            this.limit = Number(this.loanAmount) / 2;
            this.termLoan = Number(this.loanAmount) / 2;
            this.getData();
            $('#approve').modal('hide');
            $('#noinsurance').modal('hide');
            $('#approved').modal('show');
            setTimeout(() => {
              this.okFinish();
            }, 1000);
          }
        },
        (err) => {
          $('#approve').modal('hide');
          $('#noinsurance').modal('hide');
          this.approveLoanBtn = false;
          console.log(err, 'ERROR occurred');
          this.toastr.error('Something went wrong. Please try again.');
          $('#error').modal('show');
        }
      );
    }
  }

  okFinish() {
    // this.router.navigateByUrl('/sanctionedloans');
    window.location.reload();
  }

  cancelapprove() {
    $('#noinsurance').modal('hide');
    $('#approve').modal('hide');
  }

  cancelapproveI() {
    $('#noinsurance').modal('hide');
  }

  receipt() {
    let elem: HTMLElement = document.getElementById('generateReceipt');
    elem.click();
  }

  cancel() {
    window.location.href = '/loanapplications';
  }

  showMsg() {
    this.toastr.error('No deposit details found against this application.');
  }

  logout() {
    localStorage.clear();
    this.router.navigateByUrl('/login');
  }

  repayment() {
    window.location.href =
      '/loan/repayment?id=' + this.appId + '&uId=' + this.uId;
  }
  viewLoanDocs(val) {
    if (val) {
      window.open(
        val,
        '_blank' //
      );
    }
  }

  checkRemainingCapacity(cap) {
    if (cap.remainingCapacity > Number(this.appdetails.depositQty) / 1000) {
      return true;
    }
    return false;
  }

  selectLendingPartner(e) {
    this.showSaveButtonForLendingPartner = true;
    console.log(this.lendingPartner);
  }

  saveLendingPartner() {
    this.saveLpBtnClicked = true;
    let obj = {
      lendingPartnerName: this.lendingPartner.name,
      lendingPartnerID: this.lendingPartner._id,
      aId: this.appdetails['_id'],
    };
    this.lservice.saveLendingPartner(obj).subscribe(
      (data) => {
        console.log(data);
        if (data['success']) {
          this.toastr.success('Lending Partner Saved.');
          this.showSaveButtonForLendingPartner = false;
          this.saveLpBtnClicked = false;
          this.getData();
        }
      },
      (err) => {
        console.log(err);
        this.saveLpBtnClicked = false;
        this.toastr.error('Error while saving Lending Partner.');
      }
    );
  }
  cancelLendingPartnerSave() {
    this.showSaveButtonForLendingPartner = false;
  }

  // New code for branch based login
  makeItWorkWithOldCode(user) {
    if (user.userType == 'bankUser' && !user.uTypeEntity) {
      console.log('maker', user);

      return true;
    }
    //     else if (user.userType == 'bankUser' && user.uTypeEntity == 'maker'
    //     ) {
    // if(user.makerStatus!== 'approved'){
    //   return true
    // }
    // else{
    //   return true
    // }

    // return true;
    // }
    else if (user.userType == 'bankUser' && user.uTypeEntity == 'checker') {
      console.log('checker', user);
      return true;
    }

    // applicationStatus
  }

  // Added makerApprovedId in loan application
  // Fixed bchecker spelling
  // convert bechecker from string to objectId
  // Removed condition from get loan application API -> [ new CheckerUserTypeNew function] [ Removed checkUserType - function ]
  // New Function for branch based login in frontend -> makeItWorkWithOldCode
  // Changed conditions on loan application details page for Maker And Checker.

  // Add checkerApprovedId after final approval
  // checkerApprovedTimestamp
}
